module.exports = __webpack_public_path__ + "static/media/summit-invite-background.6efce978.webp";